import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { API } from '../config';
import './Auth.css';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No verification token found in the link.');
      return;
    }

    fetch(`${API}/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(r => r.json().then(data => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (ok) {
          // Store token and log user in
          localStorage.setItem('token', data.access_token);
          localStorage.setItem('user_type', data.user_type);
          localStorage.setItem('user_name', data.full_name || '');
          localStorage.setItem('user_tier', data.subscription_tier || 'free');
          setStatus('success');
          // Redirect after 2.5s
          setTimeout(() => {
            if (data.user_type === 'RECRUITER') {
              navigate('/recruiter/profile-setup');
            } else {
              navigate('/profile-setup');
            }
          }, 2500);
        } else {
          setStatus('error');
          setMessage(data.detail || 'Verification failed.');
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('Something went wrong. Please try again.');
      });
  }, []);

  return (
    <div className="auth-container">
      <div className="auth-stars">{[...Array(10)].map((_, i) => <div key={i} className="auth-star" />)}</div>
      <div className="auth-card">
        <div className="auth-header">
          <Link to="/"><img src="/JobLinkedAI.png" alt="JobLinked AI" style={{ height: 80, marginBottom: '1rem' }} /></Link>

          {status === 'verifying' && (
            <>
              <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>⏳</div>
              <h2>Verifying your email...</h2>
              <p>Just a moment</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>✅</div>
              <h2>Email verified!</h2>
              <p style={{ color: '#10b981', fontWeight: 600 }}>Welcome to JobLinked AI</p>
              <p style={{ color: '#94a3b8', fontSize: '0.85rem', marginTop: '0.5rem' }}>Redirecting you now...</p>
            </>
          )}

          {status === 'error' && (
            <>
              <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>❌</div>
              <h2>Verification failed</h2>
              <p style={{ color: '#ef4444' }}>{message}</p>
            </>
          )}
        </div>

        {status === 'error' && (
          <div style={{ padding: '0 1.5rem 1.5rem', textAlign: 'center' }}>
            <Link to="/register">
              <button className="btn btn-full">Create a new account</button>
            </Link>
            <p style={{ marginTop: '1rem', fontSize: '0.85rem', color: '#94a3b8' }}>
              Already have an account? <Link to="/login">Sign in</Link>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;
